import { Icon, Tooltip } from "@mui/material";
import {
  GridActionsCellItem,
  GridAlignment,
  GridColumns,
  GridRowParams,
} from "@mui/x-data-grid";
import { IProspect } from "../../../../../interfaces/prospect/models";
import { ICreateColumnsPros } from "./interfaces";

export const createColumns = ({
  onEdit,
  onRemove,
}: ICreateColumnsPros): GridColumns<IProspect> => [
  {
    field: "actions",
    type: "actions",
    align: "left" as GridAlignment,
    hideable: false,
    maxWidth: 100,
    getActions: (params: GridRowParams<IProspect>) => [
      <GridActionsCellItem
        placeholder={undefined}
        onResize={undefined}
        onResizeCapture={undefined}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
        icon={
          <Tooltip title="Modifica">
            <Icon className="fa-light fa-pen" sx={{ overflow: "visible" }} />
          </Tooltip>
        }
        label="Edit"
        onClick={() => onEdit(params.id as number)}
      />,
      <GridActionsCellItem
        placeholder={undefined}
        onResize={undefined}
        onResizeCapture={undefined}
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
        icon={
          <Tooltip title="Elimina">
            <Icon
              className="fa-light fa-trash-can"
              sx={{ overflow: "visible" }}
            />
          </Tooltip>
        }
        label="Delete"
        onClick={() => onRemove(params.id as number)}
      />,
    ],
  },
  {
    field: "cliente",
    headerName: "Cliente",
    width: 160,
  },
  {
    field: "societa",
    headerName: "Societa",
    width: 160,
  },
  {
    field: "societa1",
    headerName: "Societa 1",
    width: 160,
  },
  {
    field: "stato",
    headerName: "Stato",
    width: 160,
  },
  {
    field: "paese",
    headerName: "Paese",
    width: 160,
  },
  {
    field: "citta",
    headerName: "Citta",
    width: 160,
  },
  {
    field: "telefono",
    headerName: "Telefono",
    width: 160,
  },
  {
    field: "website",
    headerName: "Website",
    width: 160,
  },
  {
    field: "contatto1",
    headerName: "Contatto 1",
    width: 160,
  },
  {
    field: "telefono1",
    headerName: "Telefono 1",
    width: 160,
  },
  {
    field: "email1",
    headerName: "Email 1",
    width: 160,
  },
  {
    field: "contatto2",
    headerName: "Contatto 2",
    width: 160,
  },
  {
    field: "telefono2",
    headerName: "Telefono 2",
    width: 160,
  },
  {
    field: "email2",
    headerName: "Email 2",
    width: 160,
  },
  {
    field: "contatto3",
    headerName: "Contatto 3",
    width: 160,
  },
  {
    field: "telefono3",
    headerName: "Telefono 3",
    width: 160,
  },
  {
    field: "email3",
    headerName: "Email 3",
    width: 160,
  },
  {
    field: "agente",
    headerName: "Agente",
    width: 160,
  },
  {
    field: "responsabilegemeg",
    headerName: "Responsabile",
    width: 160,
  },
  {
    field: "tipoDisplay",
    headerName: "Tipo",
    width: 240,
  },
  {
    field: "qualitaDisplay",
    headerName: "Qualita",
    width: 320,
  },
  {
    field: "categoriaDisplay",
    headerName: "Categoria",
    width: 320,
  },
  {
    field: "usoDisplay",
    headerName: "Uso",
    width: 180,
  },
  {
    field: "notaprofilazione",
    headerName: "Nota",
    width: 360,
  },
];
